



















import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { Checkbox } from '@/components/form';
import errorsToString from '@/tools/errorsToString';
import Select from '@/components/form/Select.vue';

@Component({
  components: {
    Select,
    Checkbox,
  },
})
export default class RequestUsersList extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Array<any>;

  @Prop({ type: Object, default: null })
  readonly errors!: any;

  checked: any = {};

  get selected(): Array<string> {
    const { checked } = this;
    return Object.keys(checked).reduce((sum: Array<string>, key: string) => {
      if (checked[key]) {
        sum.push(key);
      }
      return sum;
    }, []);
  }

  get itemsAndErrors() {
    const { errors, items } = this;
    return items.map((item) => ({
      ...item,
      error: errorsToString(errors, item.id),
    }));
  }

  get eventOrderEduLevelsDict() {
    return this.$store.state.eventOrderEduLevelsDict.map((el: any) => ({
      value: el.id,
      text: el.name,
    }));
  }

  @Watch('selected')
  addChildren() {
    this.$emit('addCheckedChildren', this.selected);
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/catalog/card/components/request/components/requestform/components/userslist/RequestUsersList.vue